import { Box } from '@mui/material';
import { Controller } from 'react-hook-form';
import CustomLabel from 'components/customLabel';
import { PhoneInput } from 'react-international-phone';
import ErrorMessage from 'components/errorMessage';

type Props = {
  control: any;
  error?: any;
  name: string;
  label: string;
  variant?: string;
  disabled?: boolean;
  required?: boolean;
};

export default function Phone({ error, variant, name, control, required = true, label }: Props) {
  return (
    <Box position='relative'>
      <CustomLabel>{label ? label : 'Номер телефона:'}</CustomLabel>

      <Box pt='4px' />

      <Controller
        name={name}
        control={control}
        rules={{
          required: required,
          pattern: required
            ? {
                value: /^.{5,}$/,
                message: 'Поле, обязательное для заполнения',
              }
            : undefined,
          validate: required ? { minLength: (v) => v?.length >= 8 } : undefined,
        }}
        defaultValue={'+998'}
        render={({ field }: any) => (
          <PhoneInput
            defaultCountry='uz'
            value={field.value || ''}
            // hideDropdown={true} // country select disablded
            forceDialCode={true} // davlat raqmlarini o'chirishni blocklash
            disabled={variant === 'unstyled'}
            onChange={(values) => {
              field.onChange(values || null);
            }}
            countrySelectorStyleProps={{
              buttonStyle: {
                height: '40px',
                border:
                  variant === 'unstyled'
                    ? 'none'
                    : error?.[name]?.type === 'pattern'
                    ? '1px solid #ED665E'
                    : '1px solid #CECECE',
                background: 'transparent',
              },
            }}
            inputStyle={{
              width: '100%',
              height: '40px',
              fontWeight: 500,
              fontSize: '14px',
              fontFamily: 'Lato !important',
              border:
                variant === 'unstyled'
                  ? 'none'
                  : error?.[name]?.type === 'pattern'
                  ? '1px solid #ED665E'
                  : '1px solid #CECECE',
              background: 'transparent',
            }}
          />
        )}
      />

      <ErrorMessage error={error} name={name} />
    </Box>
  );
}
